/* tslint:disable:no-empty */
export function noop() { }



// WEBPACK FOOTER //
// ./node_modules/rxjs/src/util/noop.ts